/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vocabulary } from "../../Utils/Vocabulary";
import { AlertDrawerProps } from "../../Utils/Types";
import CustomDrawer from "../CustomDrawer";
import { FormsIds } from "../../Utils/Constants";
import OneAlert from "./OneAlert";

export default function AddNewAlert(props: AlertDrawerProps) {
  const { open, propertyOptions, ruleOptions, onClose } = props;

  return (
    <CustomDrawer
      open={open}
      handleDrawerClose={onClose}
      title={Vocabulary.alert}
      formId={FormsIds.alertForm}
    >
      <OneAlert
        onClose={() => onClose()}
        propertyOptions={propertyOptions}
        ruleOptions={ruleOptions}
      />
    </CustomDrawer>
  );
}
